import React, { createContext, useContext } from 'react';
import { PagesPilotFeatureFlags, usePagesPilotFeatureFlags } from '@Hooks/dataFetching/usePagesPilotFeatureFlags.ts';
import { PageLoading } from '@Component/Page/PageLoading.tsx';

const PilotFeatureContext = createContext<PagesPilotFeatureFlags>({} as PagesPilotFeatureFlags);

export const usePilotFeatureContext = () => {
    return useContext(PilotFeatureContext);
};

export const PilotFeatureContextProvider = ({ children }: { children: React.ReactNode }) => {
    const { data: pilotFeatures, isLoading } = usePagesPilotFeatureFlags();

    if (pilotFeatures === undefined || isLoading) {
        return <PageLoading />;
    }

    return <PilotFeatureContext.Provider value={pilotFeatures.value}>{children}</PilotFeatureContext.Provider>;
};
